module.exports = __webpack_public_path__ + "img/blue-circle-table-4.926acf5f.png";